module.exports = "/images/lifestyle.jpg";